import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "../environments/environment.production";
import { DefaultErrorMessage, ErrorMessages } from "../components/catalogoErrores/error-messages";
import { EdicionVehiculoResponseMoralVo } from "../pojos/EdicionVehiculoResponseMoralVo"; // Asegúrate de importar la interfaz correcta

@Injectable({
  providedIn: 'root'
})
export class EditarSolicitudMoralService {
  // Endpoint base puede configurarse en environment o usarse directamente
  private readonly endPoint = `${environment.HOST_EDICION}/editar-solicitud-moral`;

  constructor(
    private http: HttpClient,
  ) {}

  editarSolicitudMoral(data:string): Observable<EdicionVehiculoResponseMoralVo> {
    if (!data) {
      return throwError(() => this.createValidationError('data no puede estar vacío'));
    }


    // Construir el parámetro 'data' como en el ejemplo de la URL
    const dataParam = data;

    const params = new HttpParams()
      .set('data', dataParam);

    return this.http.get<EdicionVehiculoResponseMoralVo>(this.endPoint, { params }).pipe(
      catchError(error => {
        const customError = {
          originalError: error,
          timestamp: new Date().toISOString(),
          userMessage: error.error?.descripcionCodigo ||
            ErrorMessages[error.error?.idCodigo] ||
            ErrorMessages[error.status] ||
            DefaultErrorMessage,
          context: {
            endpoint: this.endPoint,
            params: { dataParam }
          }
        };
        console.error(customError);
        return throwError(() => customError);
      })
    );
  }

  private createValidationError(message: string): any {
    return {
      type: 'VALIDATION_ERROR',
      message,
      userMessage: message,
      timestamp: new Date().toISOString()
    };
  }
}
